// extracted by mini-css-extract-plugin
module.exports = {"timeout":"CallAndSmsCodeField_timeout__jNF9V","label":"CallAndSmsCodeField_label__cum58"};